export default __webpack_public_path__ + "static/media/daisyo.92974228.png";